import { render, staticRenderFns } from "./ontick-toggle.component.vue?vue&type=template&id=744dc682&scoped=true"
import script from "./ontick-toggle.component.vue?vue&type=script&lang=js"
export * from "./ontick-toggle.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-toggle.component.vue?vue&type=style&index=0&id=744dc682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744dc682",
  null
  
)

export default component.exports